 
<template>
  <div class="container-link-profile d-flex flex-column">
    <div
      class="info-link caption white--text text--darken-4 pt-1 pr-1 pl-2 justify-start"
    >{{ $t('LoggedArea.CopyLink.clickToProfile') }}</div>

    <div class="d-flex justify-space-between pb-1" style="padding-top: 2px;">
      <!-- user profile link -->
      <div class="d-flex justify-space between" style="width:82%; text-align: center;">
        <div
          class="box-link caption ml-2 mb-1 pl-0 pt-0 black--text text--darken-4"
          @click="openLink"
          style="overflow:hidden; width:100%; cursor: pointer; font-size: 1vw;"
        >nownow.one/{{ user.userName }}</div>
        <input id="url" type="text" :value="link" style="display:none;" />
      </div>

      <!-- copy button -->
      <div>
        <v-btn
          depressed
          small
          style="height:20px; width:50px;"
          class="mb-1 ml-1 mr-2"
          outlined
          color="white"
          @click="copyLink"
        >
          <span style="font-size:xx-small;" v-if="!copy">{{ $t('LoggedArea.CopyLink.copy')}}</span>
          <v-icon small v-else>mdi-check</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { analytics } from "@/config/firebaseConfig";
export default {
  data() {
    return {
      colorButton: "white darken-4",
      copy: false,
      completedSetting: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    link() {
      return process.env.VUE_APP_USER_URL + this.user.userName;
    },
  },
  methods: {
    copyLink() {
      const link = document.querySelector("#url");
      link.style.display = "block";
      link.focus();
      document.execCommand("SelectAll");
      document.execCommand("Copy", false, null);
      link.style.display = "none";
      this.copy = true;
      setTimeout(() => {
        this.copy = false;
      }, 3000);
      analytics.logEvent("Btn_CopyLink");
    },
    openLink() {
      window.location.href = this.link;
      analytics.logEvent("Btn_LinkProf");
    },
  },
};
</script>

<style>
.container-link-profile {
  width: 350px;
  height: 55px;
  margin: 0px auto 0px;
  background-color: #4a148c;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom: 0.5px black solid;
}
.box-link {
  border: 1px solid black;
  background: #ffff;
  border-radius: 5px;
  min-height: 90%;
}
.info-link {
  text-align: center;
}
@media (max-width: 600px) {
  .container-link-profile {
    margin: 0px auto 0px;
    width: 300px;
  }
}
</style>
